import React, { useState, useContext, useEffect, useReducer } from 'react';
import '../register.css';

const GdacsTimeline = (props) => {
    const [navIndex, setNavIndex] = React.useState(props.navIndex);
    const ColoredLine = ({ color, height, borderTop }) => (
        <hr
            style={{
                color: color,
                backgroundColor: color,
                height: height,
                width: 120,
                marginLeft: 0,
                marginRight: 0,
                marginTop: 10,
                marginBottom: 8,
                borderTop: borderTop
            }}
        />
    );

    return (
        <div>
            <div className="row d-flex justify-content-center">
                <button id="username" type="button" value="next" className={props.navIndex > 0 ? "btn-sm btn-circle-timeline_active" : "btn-sm btn-circle-timeline"} style={{textAlign:"top"}} />
                <ColoredLine color={props.navIndex > 1 ? "#3e98c7" : "gainsboro"} height={2} borderTop={"1 solid rgba(0,0,0,.1)"} />
                <button id="username" type="button" value="next" className={props.navIndex > 1 ? "btn-sm btn-circle-timeline_active" : "btn-sm btn-circle-timeline"} />
                <ColoredLine color={props.navIndex > 2 ? "#3e98c7" : "gainsboro"} height={2} borderTop={"1 solid rgba(0,0,0,.1)"} />
                <button id="username" type="button" value="next" className={props.navIndex > 2 ? "btn-sm btn-circle-timeline_active" : "btn-sm btn-circle-timeline"} />
                <ColoredLine color={props.navIndex > 3 ? "#3e98c7" : "gainsboro"} height={2} borderTop={"1 solid rgba(0,0,0,.1)"}/>
                <button id="username" type="button" value="next" className={props.navIndex > 3 ? "btn-sm btn-circle-timeline_active" : "btn-sm btn-circle-timeline"} />
                {props.user === 0 &&
                    <>
                    <ColoredLine color={props.navIndex > 4 ? "#3e98c7" : "gainsboro"} height={2} borderTop={"1 solid rgba(0,0,0,.1)"}/>
                        <button id="username" type="button" value="next" className={props.navIndex > 4 ? "btn-sm btn-circle-timeline_active" : "btn-sm btn-circle-timeline"} />
                    </>
                }
            </div>
            <div className="row d-flex justify-content-center">
                <h5 className={props.navIndex > 0 ? "timeline-text-active" : "timeline-text"}>1</h5>
                <ColoredLine color={"white"} height={0} borderTop={0} />
                <h5 className={props.navIndex > 1 ? "timeline-text-active" : "timeline-text"}>2</h5>
                <ColoredLine color={"white"} height={0} borderTop={0} />
                <h5 className={props.navIndex > 2 ? "timeline-text-active" : "timeline-text"}>3</h5>
                <ColoredLine color={"white"} height={0} borderTop={ 0}/>
                <h5 className={props.navIndex > 3 ? "timeline-text-active" : "timeline-text"}>4</h5>
                {props.user === 0 &&
                    <>
                    <ColoredLine color={"white"} height={0} borderTop={0}/>
                    <h5 className={props.navIndex > 4 ? "timeline-text-active" : "timeline-text"}>5</h5>
                </>
                }
            </div>
        </div>
    )
}

export { GdacsTimeline };